import React, { useEffect, useState } from "react";
import { getAllBNPL } from "../utils/Api/ApiCalls";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

const BNPLReqs = () => {
  const [bnplData, setBnplData] = useState([]);
  const itemsPerPage = 5;

  const [searchTerm, setSearchTerm] = useState("");
  const [temp, setTemp] = useState([]);

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % bnplData.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    getBnplReq();
  }, []);
  const getBnplReq = async () => {
    const bnplData = await getAllBNPL();
    setBnplData(bnplData?.data);
  };
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  const filteredData = bnplData.filter(
    (item) =>
      item?.fullname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const endOffset = itemOffset + itemsPerPage;
  let currentItems = filteredData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredData?.length / itemsPerPage);

  return (
    <section class="content-main">
      <div class="content-header">
        <h2 class="content-title">BNPL Requests</h2>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <header class="border-bottom mb-4 pb-4">
                <div class="row">
                  <div class="col-lg-5 col-6 me-auto">
                    <input
                      type="text"
                      placeholder="Search by Name, Email..."
                      class="form-control"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </div>
                  <div class="col-lg-2 col-6">
                    {/* <select class='form-select'>
											<option>Method</option>
											<option>Master card</option>
											<option>Visa card</option>
											<option>Paypal</option>
										</select> */}
                  </div>
                </div>
              </header>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Request ID</th>
                      <th>Fullname</th>
                      <th>Email</th>
                      <th>Phone number</th>
                      <th>Request Date</th>
                      {/* <th class="text-end">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems?.length > 0 ? (
                      currentItems?.map((item, i) => (
                        <tr key={"request x" + i}>
                          <td>
                            <b>{item?.id}</b>
                          </td>
                          <td>
                          { item?.fullName}
                          </td>
                          <td>
                            {/* <div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/1.png'
														alt='Payment'
													/>
													<span class='text text-muted'>{item.PaymentMethod}</span>
												</div> */}
                            {item?.email}
                          </td>
                          <td>{item?.phoneNum}</td>
                          <td>
                            {new Date(item?.createdAt).toDateString()}
                          </td>
                          {/* <td class="text-end">
                            <Link
                              to={`/transaction/details/${item.TransactionId}`}
                              class="btn btn-sm btn-light font-sm rounded"
                            >
                              Details
                            </Link>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>No BNPL requests</tr>
                    )}
                   
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-area mt-30 mb-50">
        <nav aria-label="Page navigation example">
          <ReactPaginate
            nextLabel="Next"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel="Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link w-auto"
            nextClassName="page-item"
            nextLinkClassName="page-link w-auto"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination justify-content-start"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </nav>
      </div>
    </section>
  );
};

export default BNPLReqs;

const toProperCase = (text) => {
  return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
};


